import { APITypesV2 } from "@cur8/api-client";
import { Locale } from "render/context/InternationalizationContext";

export function toQuestionnaireLocale(locale: Locale) {
  switch (locale) {
    case "en_GB":
      return APITypesV2.QuestionnaireLanguageCode.En;
    case "sv_SE":
      return APITypesV2.QuestionnaireLanguageCode.Sv;
  }
}
